// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"f5d80593","213":"154b2600","219":"4337a5cf","338":"20e59608","445":"1c74f97c","453":"d78d9dc6","547":"9457e260","624":"fb59ffa3","676":"ca62191f","732":"42c8a9d8","824":"1007ace4","868":"448785ae"}[chunkId] + ".chunk.js";
};